export default __webpack_public_path__ + "static/media/holidayEmpty.ae0f4245.svg";